import {LogType} from '@gongxigames/framework/core';

export const consoleReceiver = (type: any, data: any): void => {
    switch (type) {
        case LogType.Error:
            console.error(...data);/* eslint-disable-line */
            break;
        case LogType.Warning:
            console.warn(...data); /* eslint-disable-line */
            break;
        default:
            console.log(...data); /* eslint-disable-line */
    }
};
